/**
 * Browser storage that never throws. Private windows, blocked site data and some
 * embedded browsers throw on access; a preference must never break sign-in or
 * crash the shell.
 */
function area(kind: "local" | "session"): Storage | null {
  try {
    return kind === "local" ? window.localStorage : window.sessionStorage;
  } catch {
    return null;
  }
}
function make(kind: "local" | "session") {
  return {
    get(key: string): string | null {
      try { return area(kind)?.getItem(key) ?? null; } catch { return null; }
    },
    set(key: string, value: string) {
      try { area(kind)?.setItem(key, value); } catch { /* keep the in-memory value */ }
    },
    remove(key: string) {
      try { area(kind)?.removeItem(key); } catch { /* nothing stored */ }
    },
  };
}
export const local = make("local");
export const session = make("session");
